import React from "react";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import Record from "./Record";
import StandardMoney from "../../common/StandardMoney";

const {
  summaryDescription,
  entitlementDescription,
  utilisationDescription,
  balanceDescription,
} = messages;

const AccountUtilization = ({ intl, account }) => {
  const {
    entitlements = [],
    transacteds = [],
    isUnlimited,
    allocation,
    currency,
    utilization,
    balance,
  } = account;

  return (
    <div>
      <h3>{intl.formatMessage(summaryDescription)}</h3>

      <table>
        <tbody>
          <tr className="apl-payment-summary__payments">
            <td>{intl.formatMessage(entitlementDescription)}</td>

            <td className="field__currency payment__price">
              <StandardMoney value={allocation} currency={currency} />
            </td>
          </tr>

          {entitlements.map((record, idx) => {
            const { transactionType, actualAmount } = record;

            // NOTE: key always same
            return (
              <Record
                key={idx}
                intl={intl}
                transactionType={transactionType}
                actualAmount={actualAmount}
                currency={currency}
              />
            );
          })}

          <tr className="apl-payment-summary__payments">
            <td>{intl.formatMessage(utilisationDescription)}</td>

            <td className="field__currency payment__price">
              <StandardMoney value={utilization.total} currency={currency} />
            </td>
          </tr>

          {transacteds.map((record, idx) => {
            const { transactionType, actualAmount } = record;

            // NOTE: key always same
            return (
              <Record
                key={idx}
                intl={intl}
                transactionType={transactionType}
                actualAmount={actualAmount}
                currency={currency}
              />
            );
          })}

          <tr className="apl-payment-summary__total">
            <td>{intl.formatMessage(balanceDescription)}</td>

            <td className="field__currency">
              <StandardMoney value={balance} currency={currency} isUnlimited={isUnlimited} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

AccountUtilization.propTypes = {
  intl: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

export default AccountUtilization;



// WEBPACK FOOTER //
// ./components/claim/widgets/AccountUtilization.jsx